import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navbar-burger"
export default class extends Controller {
  static targets = ["burger", "menu"]

  connect() {
    this.burgerTarget.addEventListener('click', this.toggle.bind(this))
  }

  disconnect() {
    this.burgerTarget.removeEventListener('click', this.toggle.bind(this))
  }

  toggle() {
    this.burgerTarget.classList.toggle('is-active')
    this.menuTarget.classList.toggle('is-active')
  }
}
